import GoogleAuth from 'components/security/GoogleAuth';

const UserGoogleAuthPageList = () => {
	return <GoogleAuth />;
};

export default UserGoogleAuthPageList;
